// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {Op} from './op.js'

export class OpAck {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): OpAck {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsOpAck(bb: flatbuffers.ByteBuffer, obj?: OpAck): OpAck {
    return (obj || new OpAck()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsOpAck(bb: flatbuffers.ByteBuffer, obj?: OpAck): OpAck {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new OpAck()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  id(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  timestampedOp(obj?: Op): Op | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Op()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  nakError(): string | null
  nakError(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  nakError(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  duplicate(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  retryable(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startOpAck(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, idOffset, 0)
  }

  static addTimestampedOp(builder: flatbuffers.Builder, timestampedOpOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, timestampedOpOffset, 0)
  }

  static addNakError(builder: flatbuffers.Builder, nakErrorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nakErrorOffset, 0)
  }

  static addDuplicate(builder: flatbuffers.Builder, duplicate: boolean) {
    builder.addFieldInt8(3, +duplicate, null)
  }

  static addRetryable(builder: flatbuffers.Builder, retryable: boolean) {
    builder.addFieldInt8(4, +retryable, null)
  }

  static endOpAck(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // id
    return offset
  }
}
